import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";

const setSwiper = (card) => {
    const swiperContainer = card.querySelector('.c-cards-estate__thumbnail[data-swiper]');
    if(!swiperContainer) return;
    if (swiperContainer.querySelector('.swiper-wrapper') == null) return;
    // 子要素が1つだけならSwiperを初期化しない
    if (swiperContainer.querySelector('.swiper-wrapper').children.length <= 1) return;

    // 現地販売会用はSwiperを初期化しない
    if(swiperContainer.hasAttribute('data-sales')) return;

    const swiper = new Swiper(swiperContainer, {
        modules: [],
        loop: true,
        slidesPerView: 1,
        speed: 200,
    });

    const prevBtn = card.querySelector('.c-cards-estate__nav-prev');
    const nextBtn = card.querySelector('.c-cards-estate__nav-next');

    if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            swiper.slidePrev();
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            swiper.slideNext();
        });
    }

    // SP: スワイプ操作のためサムネイルをカード全面リンクより前面に出しているため、
    // タップ時は自前で物件詳細へ遷移させる(スワイプ時は tap が発火しないので誤遷移しない)
    const cardLink = card.querySelector('.c-cards-estate__link');

    if (cardLink) {
        swiper.on('tap', () => {
            window.location.href = cardLink.href;
        });
    }
}

const main = () => {
    if (document.querySelectorAll('.c-cards-estate') === null) return;

    document.querySelectorAll('.c-cards-estate').forEach(card => {
        setSwiper(card);
    });
}

export default main;
